var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.2 97.2",
    style: {
      enableBackground: "new 0 0 97.2 97.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#414042;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.6,66.7c0.2-14.4-7.1-27.9-19.6-35.5c-4.2-2.6-8.8-4.3-13.5-5.2c0.5-1.2,0.9-2.4,0.9-3.8 c0-4.8-3.9-8.8-8.8-8.8s-8.8,3.9-8.8,8.8c0,1.4,0.3,2.6,0.9,3.8c-4.7,0.9-9.3,2.6-13.5,5.2c-12.5,7.6-19.7,21-19.6,35.5 c-3.4,1.2-5.8,4.4-5.8,8.2c0,4.8,3.9,8.8,8.8,8.8h76.1c4.8,0,8.8-3.9,8.8-8.8C95.4,71.1,93,67.9,89.6,66.7z M48.6,19.3 c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.9-2.8,2.9c-0.1,0-0.1,0-0.2,0c-1.6-0.1-2.8-1.3-2.8-2.9C45.7,20.7,47,19.3,48.6,19.3z  M30.2,36.2c5.6-3.4,11.9-5.2,18.2-5.2c0.1,0,0.1,0,0.1,0c0.1,0,0.1,0,0.1,0c6.3,0,12.6,1.7,18.2,5.2 c10.5,6.4,16.8,17.7,16.8,29.9H13.5C13.5,53.9,19.7,42.6,30.2,36.2z M86.6,77.8H10.6c-1.6,0-2.9-1.3-2.9-2.9 c0-1.6,1.3-2.9,2.9-2.9h76.1c1.6,0,2.9,1.3,2.9,2.9C89.6,76.5,88.2,77.8,86.6,77.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServingIcon);
export default __webpack_public_path__ + "static/media/servingIcon.8512a2d33942fb358c924bbf6a413d4f.svg";
export { ForwardRef as ReactComponent };